var _t = { 0: 8203, 1: 8204, 2: 8205, 3: 8290, 4: 8291, 5: 8288, 6: 65279, 7: 8289, 8: 119155, 9: 119156, a: 119157, b: 119158, c: 119159, d: 119160, e: 119161, f: 119162 }, Fe = { 0: 8203, 1: 8204, 2: 8205, 3: 65279 }, St = new Array(4).fill(String.fromCodePoint(Fe[0])).join(""), gt = "\0";
function rr(t) {
  let n = JSON.stringify(t);
  return `${St}${Array.from(n).map((r) => {
    let a = r.charCodeAt(0);
    if (a > 255) throw new Error(`Only ASCII edit info can be encoded. Error attempting to encode ${n} on character ${r} (${a})`);
    return Array.from(a.toString(4).padStart(4, "0")).map((s) => String.fromCodePoint(Fe[s])).join("");
  }).join("")}`;
}
function ir(t) {
  return !Number.isNaN(Number(t)) || /[a-z]/i.test(t) && !/\d+(?:[-:\/]\d+){2}(?:T\d+(?:[-:\/]\d+){1,2}(\.\d+)?Z?)?/.test(t) ? !1 : !!Date.parse(t);
}
function sr(t) {
  try {
    new URL(t, t.startsWith("/") ? "https://acme.com" : void 0);
  } catch {
    return !1;
  }
  return !0;
}
function ar(t, n, r = "auto") {
  return r === !0 || r === "auto" && (ir(t) || sr(t)) ? t : `${t}${rr(n)}`;
}
var or = Object.fromEntries(Object.entries(Fe).map((t) => t.reverse())), ht = Object.fromEntries(Object.entries(_t).map((t) => t.reverse())), cr = `${Object.values(_t).map((t) => `\\u{${t.toString(16)}}`).join("")}`, je = new RegExp(`[${cr}]{4,}`, "gu");
function lr(t) {
  let n = t.match(je);
  if (n) return ur(n[0], !0)[0];
}
function ur(t, n = !1) {
  let r = Array.from(t);
  if (r.length % 2 === 0) {
    if (r.length % 4 || !t.startsWith(St)) return fr(r, n);
  } else throw new Error("Encoded data has invalid length");
  let a = [];
  for (let s = r.length * 0.25; s--; ) {
    let c = r.slice(s * 4, s * 4 + 4).map((u) => or[u.codePointAt(0)]).join("");
    a.unshift(String.fromCharCode(parseInt(c, 4)));
  }
  if (n) {
    a.shift();
    let s = a.indexOf(gt);
    return s === -1 && (s = a.length), [JSON.parse(a.slice(0, s).join(""))];
  }
  return a.join("").split(gt).filter(Boolean).map((s) => JSON.parse(s));
}
function fr(t, n) {
  var r;
  let a = [];
  for (let f = t.length * 0.5; f--; ) {
    let l = `${ht[t[f * 2].codePointAt(0)]}${ht[t[f * 2 + 1].codePointAt(0)]}`;
    a.unshift(String.fromCharCode(parseInt(l, 16)));
  }
  let s = [], c = [a.join("")], u = 10;
  for (; c.length; ) {
    let f = c.shift();
    try {
      if (s.push(JSON.parse(f)), n) return s;
    } catch (l) {
      if (!u--) throw l;
      let p = +((r = l.message.match(/\sposition\s(\d+)$/)) == null ? void 0 : r[1]);
      if (!p) throw l;
      c.unshift(f.substring(0, p), f.substring(p));
    }
  }
  return s;
}
function dr(t) {
  var n;
  return { cleaned: t.replace(je, ""), encoded: ((n = t.match(je)) == null ? void 0 : n[0]) || "" };
}
function ue(t, n) {
  return ar(t, n);
}
function pr(t) {
  return lr(t);
}
function ni(t) {
  return dr(t);
}
var Me, yt;
function gr() {
  if (yt) return Me;
  yt = 1;
  var t = Object.prototype.hasOwnProperty, n = Object.prototype.toString;
  return Me = function(r, a, s) {
    if (n.call(a) !== "[object Function]")
      throw new TypeError("iterator must be a function");
    var c = r.length;
    if (c === +c)
      for (var u = 0; u < c; u++)
        a.call(s, r[u], u, r);
    else
      for (var f in r)
        t.call(r, f) && a.call(s, r[f], f, r);
  }, Me;
}
var Ue, Et;
function hr() {
  if (Et) return Ue;
  Et = 1;
  var t = gr();
  Ue = n;
  function n(r, a, s) {
    if (arguments.length === 3)
      return n.set(r, a, s);
    if (arguments.length === 2)
      return n.get(r, a);
    var c = n.bind(n, r);
    for (var u in n)
      n.hasOwnProperty(u) && (c[u] = n[u].bind(c, r));
    return c;
  }
  return n.get = function(r, a) {
    for (var s = Array.isArray(a) ? a : n.parse(a), c = 0; c < s.length; ++c) {
      var u = s[c];
      if (!(typeof r == "object" && u in r))
        throw new Error("Invalid reference token: " + u);
      r = r[u];
    }
    return r;
  }, n.set = function(r, a, s) {
    var c = Array.isArray(a) ? a : n.parse(a), u = c[0];
    if (c.length === 0)
      throw Error("Can not set the root object");
    for (var f = 0; f < c.length - 1; ++f) {
      var l = c[f];
      typeof l != "string" && typeof l != "number" && (l = String(l)), !(l === "__proto__" || l === "constructor" || l === "prototype") && (l === "-" && Array.isArray(r) && (l = r.length), u = c[f + 1], l in r || (u.match(/^(\d+|-)$/) ? r[l] = [] : r[l] = {}), r = r[l]);
    }
    return u === "-" && Array.isArray(r) && (u = r.length), r[u] = s, this;
  }, n.remove = function(r, a) {
    var s = Array.isArray(a) ? a : n.parse(a), c = s[s.length - 1];
    if (c === void 0)
      throw new Error('Invalid JSON pointer for remove: "' + a + '"');
    var u = n.get(r, s.slice(0, -1));
    if (Array.isArray(u)) {
      var f = +c;
      if (c === "" && isNaN(f))
        throw new Error('Invalid array index: "' + c + '"');
      Array.prototype.splice.call(u, f, 1);
    } else
      delete u[c];
  }, n.dict = function(r, a) {
    var s = {};
    return n.walk(r, function(c, u) {
      s[u] = c;
    }, a), s;
  }, n.walk = function(r, a, s) {
    var c = [];
    s = s || function(u) {
      var f = Object.prototype.toString.call(u);
      return f === "[object Object]" || f === "[object Array]";
    }, function u(f) {
      t(f, function(l, p) {
        c.push(String(p)), s(l) ? u(l) : a(l, n.compile(c)), c.pop();
      });
    }(r);
  }, n.has = function(r, a) {
    try {
      n.get(r, a);
    } catch {
      return !1;
    }
    return !0;
  }, n.escape = function(r) {
    return r.toString().replace(/~/g, "~0").replace(/\//g, "~1");
  }, n.unescape = function(r) {
    return r.replace(/~1/g, "/").replace(/~0/g, "~");
  }, n.parse = function(r) {
    if (r === "")
      return [];
    if (r.charAt(0) !== "/")
      throw new Error("Invalid JSON pointer: " + r);
    return r.substring(1).split(/\//).map(n.unescape);
  }, n.compile = function(r) {
    return r.length === 0 ? "" : "/" + r.map(n.escape).join("/");
  }, Ue;
}
var M = hr();
const yr = ({
  pointer: t,
  mappings: n,
  data: r,
  hiddenStrings: a
}) => {
  const s = n[t];
  if (s) {
    delete n[t];
    const c = $e(r, t);
    for (const u of c) {
      n[u] = s;
      const f = M.get(r, u), l = ue(f, a);
      M.set(r, u, l);
    }
  } else {
    const c = $e(r, t);
    for (const u of c) {
      const f = M.get(r, u), l = ue(f, a);
      M.set(r, u, l);
    }
  }
};
function Er(t) {
  return "content" in t && !!t.content;
}
const $e = (t, n = "") => {
  const r = [], a = M.get(t, n);
  if (Er(a))
    for (let s = 0; s < a.content.length; s++)
      a.content[s].nodeType === "text" ? r.push(`${n}/content/${s}/value`) : r.push(...$e(t, `${n}/content/${s}`));
  return r;
}, Be = ({
  entityId: t,
  entityType: n,
  space: r,
  environment: a,
  field: s,
  locale: c,
  editorInterface: u,
  fieldType: f,
  targetOrigin: l,
  platform: p
}) => {
  const h = {
    origin: "contentful.com",
    href: `${`${l || "https://app.contentful.com"}/spaces/${r}/environments/${a}`}/${n === "Entry" ? "entries" : "assets"}/${t}/?focusedField=${s}&focusedLocale=${c}&source=vercel-content-link`,
    contentful: {
      editorInterface: u,
      fieldType: f
    }
  };
  return p === "vercel" && delete h.contentful, h;
}, It = (t) => ["builtin", "sidebar-builtin", "editor-builtin"].includes(t), At = (t) => mr.includes(t);
function wt(t) {
  if (typeof structuredClone == "function")
    return structuredClone(t);
  try {
    return JSON.parse(JSON.stringify(t));
  } catch (n) {
    return console.warn("Failed to clone data:", t, n), t;
  }
}
const mr = [
  "singleLine",
  "tagEditor",
  "listInput",
  "checkbox",
  "richTextEditor",
  "multipleLine"
];
function Ge(t, n, r, a, s, c, u) {
  const f = u ? n[u] : n;
  switch (t) {
    case "Symbol": {
      const l = ue(f, r);
      M.set(a, s, l);
      break;
    }
    case "Text": {
      const l = ue(f, r);
      M.set(a, s, l);
      break;
    }
    case "RichText": {
      yr({
        pointer: "",
        mappings: c,
        data: f,
        hiddenStrings: r
      });
      break;
    }
    case "Array": {
      const l = f.map((p) => typeof p == "string" ? ue(p, r) : p);
      M.set(a, s, l);
      break;
    }
  }
}
const ri = (t, n, r) => {
  if (!t || !t.extensions || !t.extensions.contentSourceMaps)
    return console.error(
      "GraphQL response does not contain Content Source Maps information.",
      t
    ), t;
  const a = wt(t), {
    spaces: s,
    environments: c,
    editorInterfaces: u,
    fields: f,
    locales: l,
    entries: p,
    assets: h,
    mappings: g,
    fieldTypes: m
  } = a.extensions.contentSourceMaps, I = a;
  for (const U in g) {
    const { source: S } = g[U], L = "entry" in S ? p[S.entry] : h[S.asset], K = "entry" in S ? "Entry" : "Asset";
    if (!L)
      return a;
    const x = s[L.space], $ = c[L.environment], re = L.id, fe = f[S.field], ee = l[S.locale], te = u[S.editorInterface], de = m[S.fieldType];
    if (!(It(te.widgetNamespace) && !At(te.widgetId)) && M.has(I, U)) {
      const pe = M.get(I, U);
      if (pe !== null) {
        const ie = Be({
          entityId: re,
          entityType: K,
          space: x,
          environment: $,
          field: fe,
          locale: ee,
          editorInterface: te,
          fieldType: de,
          targetOrigin: n,
          platform: r
        });
        Ge(de, pe, ie, I, U, g);
      }
    }
  }
  return a;
}, Se = (t, n, r, a, s) => {
  if (!t.fields)
    return;
  const { contentSourceMaps: c } = t.sys;
  if (!c)
    return;
  const { mappings: u } = c;
  for (const f in u) {
    const { source: l } = u[f], p = t.sys.space.sys.id, h = t.sys.environment.sys.id, g = t.sys.id, m = t.sys.type, I = n[l.fieldType], U = r[l.editorInterface];
    if (It(U.widgetNamespace) && !At(U.widgetId))
      continue;
    const S = f.startsWith("/") ? f : `/${f}`;
    if (M.has(t, S)) {
      const L = M.get(t, S);
      if (L === null)
        return;
      const K = S.split("/").pop();
      if (!K) {
        console.error("Field name could not be extracted from the pointer", S);
        return;
      }
      const x = t.sys.locale;
      if (x) {
        const $ = Be({
          entityId: g,
          entityType: m,
          space: p,
          environment: h,
          field: K,
          locale: x,
          editorInterface: U,
          fieldType: I,
          targetOrigin: a,
          platform: s
        });
        Ge(I, L, $, t, S, u);
      } else
        Object.keys(L).forEach(($) => {
          const re = Be({
            entityId: g,
            entityType: m,
            space: p,
            environment: h,
            field: K,
            locale: $,
            editorInterface: U,
            fieldType: I,
            targetOrigin: a,
            platform: s
          });
          Ge(
            I,
            L,
            re,
            t,
            `${S}/${$}`,
            u,
            $
          );
        });
    }
  }
}, ii = (t, n, r) => {
  var a;
  const s = wt(
    t
  );
  if (s.sys && "items" in s) {
    const c = s;
    if (!((a = c.sys) != null && a.contentSourceMapsLookup))
      return c;
    const {
      contentSourceMapsLookup: { fieldTypes: u, editorInterfaces: f }
    } = c.sys, { items: l, includes: p } = c;
    l.forEach(
      (h) => Se(h, u, f, n, r)
    ), p && p.Entry && p.Entry.forEach(
      (h) => Se(h, u, f, n, r)
    ), p && p.Asset && p.Asset.forEach(
      (h) => Se(h, u, f, n, r)
    );
  } else {
    const c = s;
    if (!c.sys.contentSourceMapsLookup)
      return console.error("Content source maps lookup data is missing"), c;
    Se(
      c,
      c.sys.contentSourceMapsLookup.fieldTypes,
      c.sys.contentSourceMapsLookup.editorInterfaces,
      n,
      r
    );
  }
  return s;
}, vr = "4.6.39", Ct = {
  version: vr
};
let Ot = !1;
function mt(t) {
  Ot = t;
}
const xe = (t) => (...n) => {
  Ot && console[t](...n);
}, D = {
  error: xe("error"),
  warn: xe("warn"),
  log: xe("log")
};
function br(t, n = 500) {
  let r = window.location.href;
  const s = setInterval(() => {
    const c = window.location.href;
    c !== r && (r = c, t(c));
  }, n);
  return () => clearInterval(s);
}
const Tr = "live-preview-editor", _r = "live-preview-sdk";
function G(t, n, r) {
  const a = {
    ...n,
    method: t,
    source: _r,
    location: window.location.href,
    version: Ct.version
  };
  D.log("Send message", a), r.forEach((s) => {
    window.top?.postMessage(a, s);
  });
}
function Sr(t, n = 100) {
  let r;
  return (...a) => {
    clearTimeout(r), r = setTimeout(() => {
      t.apply(this, a);
    }, n);
  };
}
function Ir() {
  try {
    return window.top?.location.href !== window.location.href;
  } catch {
    return !0;
  }
}
function Ar() {
  return `${performance.now()}-${Math.random().toString(36).slice(2)}`;
}
function wr(t) {
  return typeof t.data != "object" || !t.data ? !1 : "source" in t.data && t.data.source === Tr;
}
var Ie = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Cr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var le = { exports: {} };
le.exports;
var vt;
function Or() {
  return vt || (vt = 1, function(t, n) {
    var r = 200, a = "__lodash_hash_undefined__", s = 1, c = 2, u = 9007199254740991, f = "[object Arguments]", l = "[object Array]", p = "[object AsyncFunction]", h = "[object Boolean]", g = "[object Date]", m = "[object Error]", I = "[object Function]", U = "[object GeneratorFunction]", S = "[object Map]", L = "[object Number]", K = "[object Null]", x = "[object Object]", $ = "[object Promise]", re = "[object Proxy]", fe = "[object RegExp]", ee = "[object Set]", te = "[object String]", de = "[object Symbol]", pe = "[object Undefined]", ie = "[object WeakMap]", He = "[object ArrayBuffer]", ge = "[object DataView]", Mt = "[object Float32Array]", Ut = "[object Float64Array]", xt = "[object Int8Array]", jt = "[object Int16Array]", $t = "[object Int32Array]", Bt = "[object Uint8Array]", Gt = "[object Uint8ClampedArray]", Pt = "[object Uint16Array]", Ft = "[object Uint32Array]", zt = /[\\^$.*+?()[\]{}|]/g, Ht = /^\[object .+?Constructor\]$/, Vt = /^(?:0|[1-9]\d*)$/, v = {};
    v[Mt] = v[Ut] = v[xt] = v[jt] = v[$t] = v[Bt] = v[Gt] = v[Pt] = v[Ft] = !0, v[f] = v[l] = v[He] = v[h] = v[ge] = v[g] = v[m] = v[I] = v[S] = v[L] = v[x] = v[fe] = v[ee] = v[te] = v[ie] = !1;
    var Ve = typeof Ie == "object" && Ie && Ie.Object === Object && Ie, Yt = typeof self == "object" && self && self.Object === Object && self, F = Ve || Yt || Function("return this")(), Ye = n && !n.nodeType && n, qe = Ye && !0 && t && !t.nodeType && t, Ke = qe && qe.exports === Ye, Ae = Ke && Ve.process, Je = function() {
      try {
        return Ae && Ae.binding && Ae.binding("util");
      } catch {
      }
    }(), We = Je && Je.isTypedArray;
    function qt(e, i) {
      for (var o = -1, d = e == null ? 0 : e.length, b = 0, y = []; ++o < d; ) {
        var _ = e[o];
        i(_, o, e) && (y[b++] = _);
      }
      return y;
    }
    function Kt(e, i) {
      for (var o = -1, d = i.length, b = e.length; ++o < d; )
        e[b + o] = i[o];
      return e;
    }
    function Jt(e, i) {
      for (var o = -1, d = e == null ? 0 : e.length; ++o < d; )
        if (i(e[o], o, e))
          return !0;
      return !1;
    }
    function Wt(e, i) {
      for (var o = -1, d = Array(e); ++o < e; )
        d[o] = i(o);
      return d;
    }
    function Zt(e) {
      return function(i) {
        return e(i);
      };
    }
    function Xt(e, i) {
      return e.has(i);
    }
    function Qt(e, i) {
      return e?.[i];
    }
    function kt(e) {
      var i = -1, o = Array(e.size);
      return e.forEach(function(d, b) {
        o[++i] = [b, d];
      }), o;
    }
    function en(e, i) {
      return function(o) {
        return e(i(o));
      };
    }
    function tn(e) {
      var i = -1, o = Array(e.size);
      return e.forEach(function(d) {
        o[++i] = d;
      }), o;
    }
    var nn = Array.prototype, rn = Function.prototype, he = Object.prototype, we = F["__core-js_shared__"], Ze = rn.toString, B = he.hasOwnProperty, Xe = function() {
      var e = /[^.]+$/.exec(we && we.keys && we.keys.IE_PROTO || "");
      return e ? "Symbol(src)_1." + e : "";
    }(), Qe = he.toString, sn = RegExp(
      "^" + Ze.call(B).replace(zt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), ke = Ke ? F.Buffer : void 0, ye = F.Symbol, et = F.Uint8Array, tt = he.propertyIsEnumerable, an = nn.splice, J = ye ? ye.toStringTag : void 0, nt = Object.getOwnPropertySymbols, on = ke ? ke.isBuffer : void 0, cn = en(Object.keys, Object), Ce = ne(F, "DataView"), se = ne(F, "Map"), Oe = ne(F, "Promise"), De = ne(F, "Set"), Le = ne(F, "WeakMap"), ae = ne(Object, "create"), ln = X(Ce), un = X(se), fn = X(Oe), dn = X(De), pn = X(Le), rt = ye ? ye.prototype : void 0, Ne = rt ? rt.valueOf : void 0;
    function W(e) {
      var i = -1, o = e == null ? 0 : e.length;
      for (this.clear(); ++i < o; ) {
        var d = e[i];
        this.set(d[0], d[1]);
      }
    }
    function gn() {
      this.__data__ = ae ? ae(null) : {}, this.size = 0;
    }
    function hn(e) {
      var i = this.has(e) && delete this.__data__[e];
      return this.size -= i ? 1 : 0, i;
    }
    function yn(e) {
      var i = this.__data__;
      if (ae) {
        var o = i[e];
        return o === a ? void 0 : o;
      }
      return B.call(i, e) ? i[e] : void 0;
    }
    function En(e) {
      var i = this.__data__;
      return ae ? i[e] !== void 0 : B.call(i, e);
    }
    function mn(e, i) {
      var o = this.__data__;
      return this.size += this.has(e) ? 0 : 1, o[e] = ae && i === void 0 ? a : i, this;
    }
    W.prototype.clear = gn, W.prototype.delete = hn, W.prototype.get = yn, W.prototype.has = En, W.prototype.set = mn;
    function z(e) {
      var i = -1, o = e == null ? 0 : e.length;
      for (this.clear(); ++i < o; ) {
        var d = e[i];
        this.set(d[0], d[1]);
      }
    }
    function vn() {
      this.__data__ = [], this.size = 0;
    }
    function bn(e) {
      var i = this.__data__, o = me(i, e);
      if (o < 0)
        return !1;
      var d = i.length - 1;
      return o == d ? i.pop() : an.call(i, o, 1), --this.size, !0;
    }
    function Tn(e) {
      var i = this.__data__, o = me(i, e);
      return o < 0 ? void 0 : i[o][1];
    }
    function _n(e) {
      return me(this.__data__, e) > -1;
    }
    function Sn(e, i) {
      var o = this.__data__, d = me(o, e);
      return d < 0 ? (++this.size, o.push([e, i])) : o[d][1] = i, this;
    }
    z.prototype.clear = vn, z.prototype.delete = bn, z.prototype.get = Tn, z.prototype.has = _n, z.prototype.set = Sn;
    function Z(e) {
      var i = -1, o = e == null ? 0 : e.length;
      for (this.clear(); ++i < o; ) {
        var d = e[i];
        this.set(d[0], d[1]);
      }
    }
    function In() {
      this.size = 0, this.__data__ = {
        hash: new W(),
        map: new (se || z)(),
        string: new W()
      };
    }
    function An(e) {
      var i = ve(this, e).delete(e);
      return this.size -= i ? 1 : 0, i;
    }
    function wn(e) {
      return ve(this, e).get(e);
    }
    function Cn(e) {
      return ve(this, e).has(e);
    }
    function On(e, i) {
      var o = ve(this, e), d = o.size;
      return o.set(e, i), this.size += o.size == d ? 0 : 1, this;
    }
    Z.prototype.clear = In, Z.prototype.delete = An, Z.prototype.get = wn, Z.prototype.has = Cn, Z.prototype.set = On;
    function Ee(e) {
      var i = -1, o = e == null ? 0 : e.length;
      for (this.__data__ = new Z(); ++i < o; )
        this.add(e[i]);
    }
    function Dn(e) {
      return this.__data__.set(e, a), this;
    }
    function Ln(e) {
      return this.__data__.has(e);
    }
    Ee.prototype.add = Ee.prototype.push = Dn, Ee.prototype.has = Ln;
    function V(e) {
      var i = this.__data__ = new z(e);
      this.size = i.size;
    }
    function Nn() {
      this.__data__ = new z(), this.size = 0;
    }
    function Rn(e) {
      var i = this.__data__, o = i.delete(e);
      return this.size = i.size, o;
    }
    function Mn(e) {
      return this.__data__.get(e);
    }
    function Un(e) {
      return this.__data__.has(e);
    }
    function xn(e, i) {
      var o = this.__data__;
      if (o instanceof z) {
        var d = o.__data__;
        if (!se || d.length < r - 1)
          return d.push([e, i]), this.size = ++o.size, this;
        o = this.__data__ = new Z(d);
      }
      return o.set(e, i), this.size = o.size, this;
    }
    V.prototype.clear = Nn, V.prototype.delete = Rn, V.prototype.get = Mn, V.prototype.has = Un, V.prototype.set = xn;
    function jn(e, i) {
      var o = be(e), d = !o && Xn(e), b = !o && !d && Re(e), y = !o && !d && !b && dt(e), _ = o || d || b || y, A = _ ? Wt(e.length, String) : [], w = A.length;
      for (var T in e)
        B.call(e, T) && !(_ && // Safari 9 has enumerable `arguments.length` in strict mode.
        (T == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        b && (T == "offset" || T == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        y && (T == "buffer" || T == "byteLength" || T == "byteOffset") || // Skip index properties.
        qn(T, w))) && A.push(T);
      return A;
    }
    function me(e, i) {
      for (var o = e.length; o--; )
        if (ct(e[o][0], i))
          return o;
      return -1;
    }
    function $n(e, i, o) {
      var d = i(e);
      return be(e) ? d : Kt(d, o(e));
    }
    function oe(e) {
      return e == null ? e === void 0 ? pe : K : J && J in Object(e) ? Vn(e) : Zn(e);
    }
    function it(e) {
      return ce(e) && oe(e) == f;
    }
    function st(e, i, o, d, b) {
      return e === i ? !0 : e == null || i == null || !ce(e) && !ce(i) ? e !== e && i !== i : Bn(e, i, o, d, st, b);
    }
    function Bn(e, i, o, d, b, y) {
      var _ = be(e), A = be(i), w = _ ? l : Y(e), T = A ? l : Y(i);
      w = w == f ? x : w, T = T == f ? x : T;
      var O = w == x, j = T == x, C = w == T;
      if (C && Re(e)) {
        if (!Re(i))
          return !1;
        _ = !0, O = !1;
      }
      if (C && !O)
        return y || (y = new V()), _ || dt(e) ? at(e, i, o, d, b, y) : zn(e, i, w, o, d, b, y);
      if (!(o & s)) {
        var N = O && B.call(e, "__wrapped__"), R = j && B.call(i, "__wrapped__");
        if (N || R) {
          var q = N ? e.value() : e, H = R ? i.value() : i;
          return y || (y = new V()), b(q, H, o, d, y);
        }
      }
      return C ? (y || (y = new V()), Hn(e, i, o, d, b, y)) : !1;
    }
    function Gn(e) {
      if (!ft(e) || Jn(e))
        return !1;
      var i = lt(e) ? sn : Ht;
      return i.test(X(e));
    }
    function Pn(e) {
      return ce(e) && ut(e.length) && !!v[oe(e)];
    }
    function Fn(e) {
      if (!Wn(e))
        return cn(e);
      var i = [];
      for (var o in Object(e))
        B.call(e, o) && o != "constructor" && i.push(o);
      return i;
    }
    function at(e, i, o, d, b, y) {
      var _ = o & s, A = e.length, w = i.length;
      if (A != w && !(_ && w > A))
        return !1;
      var T = y.get(e);
      if (T && y.get(i))
        return T == i;
      var O = -1, j = !0, C = o & c ? new Ee() : void 0;
      for (y.set(e, i), y.set(i, e); ++O < A; ) {
        var N = e[O], R = i[O];
        if (d)
          var q = _ ? d(R, N, O, i, e, y) : d(N, R, O, e, i, y);
        if (q !== void 0) {
          if (q)
            continue;
          j = !1;
          break;
        }
        if (C) {
          if (!Jt(i, function(H, Q) {
            if (!Xt(C, Q) && (N === H || b(N, H, o, d, y)))
              return C.push(Q);
          })) {
            j = !1;
            break;
          }
        } else if (!(N === R || b(N, R, o, d, y))) {
          j = !1;
          break;
        }
      }
      return y.delete(e), y.delete(i), j;
    }
    function zn(e, i, o, d, b, y, _) {
      switch (o) {
        case ge:
          if (e.byteLength != i.byteLength || e.byteOffset != i.byteOffset)
            return !1;
          e = e.buffer, i = i.buffer;
        case He:
          return !(e.byteLength != i.byteLength || !y(new et(e), new et(i)));
        case h:
        case g:
        case L:
          return ct(+e, +i);
        case m:
          return e.name == i.name && e.message == i.message;
        case fe:
        case te:
          return e == i + "";
        case S:
          var A = kt;
        case ee:
          var w = d & s;
          if (A || (A = tn), e.size != i.size && !w)
            return !1;
          var T = _.get(e);
          if (T)
            return T == i;
          d |= c, _.set(e, i);
          var O = at(A(e), A(i), d, b, y, _);
          return _.delete(e), O;
        case de:
          if (Ne)
            return Ne.call(e) == Ne.call(i);
      }
      return !1;
    }
    function Hn(e, i, o, d, b, y) {
      var _ = o & s, A = ot(e), w = A.length, T = ot(i), O = T.length;
      if (w != O && !_)
        return !1;
      for (var j = w; j--; ) {
        var C = A[j];
        if (!(_ ? C in i : B.call(i, C)))
          return !1;
      }
      var N = y.get(e);
      if (N && y.get(i))
        return N == i;
      var R = !0;
      y.set(e, i), y.set(i, e);
      for (var q = _; ++j < w; ) {
        C = A[j];
        var H = e[C], Q = i[C];
        if (d)
          var pt = _ ? d(Q, H, C, i, e, y) : d(H, Q, C, e, i, y);
        if (!(pt === void 0 ? H === Q || b(H, Q, o, d, y) : pt)) {
          R = !1;
          break;
        }
        q || (q = C == "constructor");
      }
      if (R && !q) {
        var Te = e.constructor, _e = i.constructor;
        Te != _e && "constructor" in e && "constructor" in i && !(typeof Te == "function" && Te instanceof Te && typeof _e == "function" && _e instanceof _e) && (R = !1);
      }
      return y.delete(e), y.delete(i), R;
    }
    function ot(e) {
      return $n(e, er, Yn);
    }
    function ve(e, i) {
      var o = e.__data__;
      return Kn(i) ? o[typeof i == "string" ? "string" : "hash"] : o.map;
    }
    function ne(e, i) {
      var o = Qt(e, i);
      return Gn(o) ? o : void 0;
    }
    function Vn(e) {
      var i = B.call(e, J), o = e[J];
      try {
        e[J] = void 0;
        var d = !0;
      } catch {
      }
      var b = Qe.call(e);
      return d && (i ? e[J] = o : delete e[J]), b;
    }
    var Yn = nt ? function(e) {
      return e == null ? [] : (e = Object(e), qt(nt(e), function(i) {
        return tt.call(e, i);
      }));
    } : tr, Y = oe;
    (Ce && Y(new Ce(new ArrayBuffer(1))) != ge || se && Y(new se()) != S || Oe && Y(Oe.resolve()) != $ || De && Y(new De()) != ee || Le && Y(new Le()) != ie) && (Y = function(e) {
      var i = oe(e), o = i == x ? e.constructor : void 0, d = o ? X(o) : "";
      if (d)
        switch (d) {
          case ln:
            return ge;
          case un:
            return S;
          case fn:
            return $;
          case dn:
            return ee;
          case pn:
            return ie;
        }
      return i;
    });
    function qn(e, i) {
      return i = i ?? u, !!i && (typeof e == "number" || Vt.test(e)) && e > -1 && e % 1 == 0 && e < i;
    }
    function Kn(e) {
      var i = typeof e;
      return i == "string" || i == "number" || i == "symbol" || i == "boolean" ? e !== "__proto__" : e === null;
    }
    function Jn(e) {
      return !!Xe && Xe in e;
    }
    function Wn(e) {
      var i = e && e.constructor, o = typeof i == "function" && i.prototype || he;
      return e === o;
    }
    function Zn(e) {
      return Qe.call(e);
    }
    function X(e) {
      if (e != null) {
        try {
          return Ze.call(e);
        } catch {
        }
        try {
          return e + "";
        } catch {
        }
      }
      return "";
    }
    function ct(e, i) {
      return e === i || e !== e && i !== i;
    }
    var Xn = it(/* @__PURE__ */ function() {
      return arguments;
    }()) ? it : function(e) {
      return ce(e) && B.call(e, "callee") && !tt.call(e, "callee");
    }, be = Array.isArray;
    function Qn(e) {
      return e != null && ut(e.length) && !lt(e);
    }
    var Re = on || nr;
    function kn(e, i) {
      return st(e, i);
    }
    function lt(e) {
      if (!ft(e))
        return !1;
      var i = oe(e);
      return i == I || i == U || i == p || i == re;
    }
    function ut(e) {
      return typeof e == "number" && e > -1 && e % 1 == 0 && e <= u;
    }
    function ft(e) {
      var i = typeof e;
      return e != null && (i == "object" || i == "function");
    }
    function ce(e) {
      return e != null && typeof e == "object";
    }
    var dt = We ? Zt(We) : Pn;
    function er(e) {
      return Qn(e) ? jn(e) : Fn(e);
    }
    function tr() {
      return [];
    }
    function nr() {
      return !1;
    }
    t.exports = kn;
  }(le, le.exports)), le.exports;
}
var Dr = Or();
const Lr = /* @__PURE__ */ Cr(Dr);
var E = /* @__PURE__ */ ((t) => (t.FIELD_ID = "data-contentful-field-id", t.ENTRY_ID = "data-contentful-entry-id", t.ASSET_ID = "data-contentful-asset-id", t.LOCALE = "data-contentful-locale", t.SPACE = "data-contentful-space", t.ENVIRONMENT = "data-contentful-environment", t))(E || {}), k = /* @__PURE__ */ ((t) => (t.MOUSE_MOVE = "MOUSE_MOVE", t.SCROLL_START = "SCROLL_START", t.SCROLL_END = "SCROLL_END", t.RESIZE_START = "RESIZE_START", t.RESIZE_END = "RESIZE_END", t.TAGGED_ELEMENTS = "TAGGED_ELEMENTS", t.INSPECTOR_MODE_CHANGED = "INSPECTOR_MODE_CHANGED", t))(k || {}), Dt = { 0: 8203, 1: 8204, 2: 8205, 3: 8290, 4: 8291, 5: 8288, 6: 65279, 7: 8289, 8: 119155, 9: 119156, a: 119157, b: 119158, c: 119159, d: 119160, e: 119161, f: 119162 }, Lt = { 0: 8203, 1: 8204, 2: 8205, 3: 65279 };
new Array(4).fill(String.fromCodePoint(Lt[0])).join("");
Object.fromEntries(Object.entries(Lt).map((t) => t.reverse()));
Object.fromEntries(Object.entries(Dt).map((t) => t.reverse()));
var Nr = `${Object.values(Dt).map((t) => `\\u{${t.toString(16)}}`).join("")}`, Rr = new RegExp(`[${Nr}]{4,}`, "gu");
const Mr = (t) => {
  if (!t || t.nodeType !== Node.ELEMENT_NODE)
    return !1;
  const n = t;
  return !(!n.hasAttribute(E.FIELD_ID) || !n.hasAttribute(E.ENTRY_ID) && !n.hasAttribute(E.ASSET_ID));
};
function Ur(t, n) {
  if (!Mr(t))
    return null;
  const r = {
    fieldId: t.getAttribute(E.FIELD_ID),
    locale: t.getAttribute(E.LOCALE) ?? n.locale,
    environment: t.getAttribute(E.ENVIRONMENT) ?? n.environment,
    space: t.getAttribute(E.SPACE) ?? n.space,
    manuallyTagged: !0
  };
  if (!r.fieldId)
    return D.warn("Element is missing field ID attribute and cannot be tagged", {
      id: t.getAttribute(E.ENTRY_ID) ?? t.getAttribute(E.ASSET_ID),
      sharedProps: r
    }), null;
  const a = t.getAttribute(E.ENTRY_ID);
  if (a)
    return { ...r, entryId: a };
  const s = t.getAttribute(E.ASSET_ID);
  return s ? { ...r, assetId: s } : null;
}
function Nt(t, n) {
  return t.href === n.href;
}
function xr(t, n) {
  return !(!Nt(t.sourceMap, n.sourceMap) || t.element !== n.element);
}
function jr(t) {
  let n = [];
  return typeof t.matches == "function" && t.matches("*") && (n = [t]), [
    ...n,
    ...Array.from(t.querySelectorAll("*:not(script,style,meta,title)"))
  ].map((r) => ({ node: r, text: $r(r) })).filter(({ text: r }) => !!(r && r.match(Rr)));
}
function $r(t) {
  return t.matches("input[type=submit], input[type=button], input[type=reset]") ? t.value : t.matches("img, video") ? t.alt : Array.from(t.childNodes).filter((n) => n.nodeType === Node.TEXT_NODE && !!n.textContent).map((n) => n.textContent).join("");
}
function Br(t, n) {
  for (const r of n)
    if (r.element === t || r.element.contains(t))
      return !0;
  return !1;
}
function ze({
  root: t = window.document,
  options: n
}) {
  const a = [...n.ignoreManuallyTaggedElements ? [] : t.querySelectorAll(
    `[${E.ASSET_ID}][${E.FIELD_ID}], [${E.ENTRY_ID}][${E.FIELD_ID}]`
  )].map((l) => ({
    element: l,
    attributes: Ur(l, n)
  })).filter(({ attributes: l }) => l !== null), s = [], c = jr("body" in t ? t.body : t);
  for (const { node: l, text: p } of c) {
    const h = pr(p);
    if (!h || !h.origin.includes("contentful.com")) {
      D.warn(
        "Element has missing or invalid ContentSourceMap, please check if you have correctly enabled ContentSourceMaps and that the element's data originates from Contentful",
        {
          node: l,
          sourceMap: h
        }
      );
      continue;
    }
    if (!(Br(l, a) || s.some(
      (g) => g.element.contains(l) && Nt(g.sourceMap, h)
    ))) {
      if (l.matches("img")) {
        const g = l.closest("figure") || l.closest("picture") || l;
        s.push({ element: g, sourceMap: h });
        continue;
      }
      s.push({ element: l, sourceMap: h });
    }
  }
  const u = s.filter(
    (l, p) => s.findIndex((h) => xr(l, h)) === p
  );
  for (const { element: l, sourceMap: p } of u) {
    let h = null;
    if (p.href) {
      const g = Hr(p.href);
      if (!g)
        continue;
      if (g.entityType === "Asset")
        h = {
          fieldId: g.fieldId,
          locale: g.locale,
          space: g.space,
          environment: g.environment,
          assetId: g.entityId
        };
      else if (g.entityType === "Entry")
        h = {
          fieldId: g.fieldId,
          locale: g.locale,
          space: g.space,
          environment: g.environment,
          entryId: g.entityId
        };
      else {
        D.warn("Unknown entityType", {
          element: l,
          sourceMap: p
        });
        continue;
      }
    } else if (p.contentful && Vr(p.contentful)) {
      const g = p.contentful;
      if (!g.entity || !g.field || !g.locale || !g.space || !g.environment) {
        D.warn(
          "Element has missing information in their ContentSourceMap, please check if you have restricted the platform for the encoding. (Missing parameters in `contentful`)",
          {
            element: l,
            sourceMap: p
          }
        );
        continue;
      }
      const m = {
        fieldId: g.field,
        locale: g.locale,
        space: g.space,
        environment: g.environment
      };
      if (g.entityType === "Asset")
        m.assetId = g.entity, h = m;
      else if (g.entityType === "Entry")
        m.entryId = g.entity, h = m;
      else {
        D.warn("Unknown entityType in contentful data", {
          element: l,
          sourceMap: p
        });
        continue;
      }
    } else {
      D.warn(
        "Element has neither href nor contentful data in their ContentSourceMap, unable to extract attributes.",
        {
          element: l,
          sourceMap: p
        }
      );
      continue;
    }
    a.push({
      element: l,
      attributes: h
    });
  }
  const f = a.filter(
    ({ attributes: l }) => l?.manuallyTagged === !1 || !l?.manuallyTagged
  ).length;
  return {
    taggedElements: a,
    manuallyTaggedCount: a.length - f,
    automaticallyTaggedCount: f,
    autoTaggedElements: u
  };
}
function Rt({
  options: t
}) {
  return [
    ...new Set(
      ze({ options: t }).taggedElements.map((n) => n.attributes && "entryId" in n.attributes ? n.attributes.entryId : null).filter(Boolean)
    )
  ];
}
const Gr = (t, n, r = window.document) => {
  const { top: a, right: s, bottom: c, left: u } = n, f = r.elementFromPoint(u + 1, a + 1), l = r.elementFromPoint(s - 1, a + 1), p = r.elementFromPoint(u + 1, c - 1), h = r.elementFromPoint(s - 1, c - 1);
  return !(f === t && l === t && p === t && h === t);
}, Pr = (t, n = window.document) => t.map((r) => ({
  ...r,
  isVisible: r.element.checkVisibility({
    checkOpacity: !0,
    checkVisibilityCSS: !0
  }),
  isCoveredByOtherElement: Gr(
    r.element,
    r.coordinates,
    n
  )
})), Fr = (t) => t.map(({ element: n, attributes: r }) => ({
  element: n,
  coordinates: n.getBoundingClientRect(),
  attributes: r
})), zr = (t, n = window.document) => {
  const r = Fr(t);
  return Pr(r, n);
};
function Hr(t) {
  try {
    const n = new URL(t), r = n.searchParams.get("focusedField"), a = n.searchParams.get("focusedLocale"), s = n.pathname.split("/").filter(Boolean), c = s.indexOf("spaces"), u = s.indexOf("environments"), f = c !== -1 ? s[c + 1] : void 0, l = u !== -1 ? s[u + 1] : void 0;
    let p, h;
    const g = s.indexOf("entries"), m = s.indexOf("assets");
    return g !== -1 ? (p = "Entry", h = s[g + 1]) : m !== -1 && (p = "Asset", h = s[m + 1]), !p || !h ? (console.warn("Unable to determine entityType or entityId from href", { href: t }), null) : r ? a ? !f || !l ? (console.warn("Missing space or environment in href path", { href: t }), null) : {
      entityId: h,
      entityType: p,
      fieldId: r,
      locale: a,
      space: f,
      environment: l
    } : (console.warn("Missing focusedLocale query parameter in href", { href: t }), null) : (console.warn("Missing focusedField query parameter in href", { href: t }), null);
  } catch (n) {
    return console.warn("Invalid href URL", { href: t, error: n }), null;
  }
}
function Vr(t) {
  return t && typeof t.entity == "string" && typeof t.field == "string" && typeof t.locale == "string" && typeof t.space == "string" && typeof t.environment == "string" && (t.entityType === "Asset" || t.entityType === "Entry");
}
class Yr {
  constructor(n) {
    this.options = n, this.intersectionObserver = new IntersectionObserver(
      (r) => {
        const a = this.taggedElements;
        for (const s of r)
          if (s.isIntersecting)
            for (const c of a)
              c.element === s.target && (c.coordinates = s.intersectionRect, c.isVisible = s.target.checkVisibility({
                checkOpacity: !0,
                checkVisibilityCSS: !0
              }));
        this.taggedElements = a, this.sendTaggedElements();
      },
      { threshold: 0.15 }
    );
  }
  delay = 300;
  isScrolling = !1;
  scrollTimeout;
  isResizing = !1;
  resizeTimeout;
  hoveredElement;
  taggedElements = [];
  manuallyTaggedCount = 0;
  automaticallyTaggedCount = 0;
  intersectionObserver;
  observersCB = [];
  cleanupCB = [];
  /**
   * Attaches the event listeners and send the tagged elements once
   */
  init = () => {
    this.cleanupCB = [
      this.addScrollListener(),
      this.addMutationListener(document.body),
      this.addResizeListener(),
      this.addHoverListener()
    ], this.updateElements();
  };
  /**
   * Cancels all listeners and observers
   */
  cleanup = () => {
    this.observersCB.forEach((n) => n()), this.cleanupCB.forEach((n) => n());
  };
  // Handles incoming messages from Contentful
  receiveMessage = (n) => {
    if (n.method === k.INSPECTOR_MODE_CHANGED) {
      const { isInspectorActive: r } = n;
      r ? this.init() : this.cleanup();
    }
  };
  /** Listen for changes on the element via intersection and mutation observer */
  observe = (n) => {
    this.intersectionObserver.observe(n);
    const r = this.addMutationListener(n);
    this.observersCB.push(r, () => this.intersectionObserver.unobserve(n));
  };
  /** Sends scroll start and end event to the editor, on end it also sends the tagged elements again */
  addScrollListener = () => {
    const { targetOrigin: n } = this.options, r = () => {
      this.isScrolling || (this.isScrolling = !0, G(k.SCROLL_START, {}, n)), this.scrollTimeout && clearTimeout(this.scrollTimeout), this.scrollTimeout = setTimeout(() => {
        this.isScrolling = !1, G(k.SCROLL_END, {}, n), this.updateElements();
      }, this.delay);
    }, a = { capture: !0, passive: !0 };
    return window.addEventListener("scroll", r, a), () => window.removeEventListener("scroll", r, a);
  };
  /** Detects DOM changes and sends the tagged elements to the editor */
  addMutationListener = (n) => {
    const r = new MutationObserver(() => {
      this.updateElements();
    });
    return r.observe(n, {
      // Content source maps
      characterData: !0,
      // Manual tagging
      attributes: !0,
      attributeFilter: [
        E.ENTRY_ID,
        E.FIELD_ID,
        E.LOCALE,
        E.SPACE,
        E.ENVIRONMENT,
        "class",
        "style"
      ],
      // Adding or removal of new nodes
      childList: !0,
      // Include children
      subtree: !0
    }), () => r.disconnect();
  };
  /** Sends resize start and end event to the editor, on end it also sends the tagged elements again */
  addResizeListener = () => {
    const { targetOrigin: n } = this.options, r = new ResizeObserver(() => {
      this.isResizing || (this.isResizing = !0, G(k.RESIZE_START, {}, n)), this.resizeTimeout && clearTimeout(this.resizeTimeout), this.resizeTimeout = setTimeout(() => {
        this.isResizing = !1, G(k.RESIZE_END, {}, n), this.updateElements();
      }, this.delay);
    });
    return r.observe(document.body), () => r.disconnect();
  };
  /** Checks if the hovered element is an tagged entry and then sends it to the editor */
  addHoverListener = () => {
    const n = Sr((a) => {
      let s;
      for (const c of a) {
        const u = c;
        if (u.nodeName === "BODY") break;
        const f = this.taggedElements.find((l) => l.element === u);
        if (f) {
          s = f;
          break;
        }
      }
      this.hoveredElement = s?.element, this.updateElements();
    }, this.delay), r = (a) => {
      n(a.composedPath());
    };
    return window.addEventListener("mouseover", r, { passive: !0 }), () => window.removeEventListener("mouseover", r);
  };
  sendTaggedElements = () => {
    G(
      k.TAGGED_ELEMENTS,
      {
        elements: this.taggedElements.map((n) => ({
          // Important: do not add `element` as it can't be cloned by sendMessage
          coordinates: n.coordinates,
          isVisible: !!n.isVisible,
          attributes: n.attributes,
          isHovered: this.hoveredElement === n.element,
          isCoveredByOtherElement: !!n.isCoveredByOtherElement
        })),
        automaticallyTaggedCount: this.automaticallyTaggedCount,
        manuallyTaggedCount: this.manuallyTaggedCount
      },
      this.options.targetOrigin
    );
  };
  /**
   * Finds all elements that have all inspector mode attributes
   * and sends them to the editor
   */
  updateElements = () => {
    const { taggedElements: n, manuallyTaggedCount: r, automaticallyTaggedCount: a } = ze({
      options: this.options
    }), s = zr(n);
    Lr(s, this.taggedElements) || (this.observersCB.forEach((c) => c()), this.observersCB = [], this.taggedElements = s, n.forEach(({ element: c }) => this.observe(c)), this.manuallyTaggedCount = r, this.automaticallyTaggedCount = a);
  };
}
const { stringify: qr } = JSON, Kr = String, Jr = "string", Wr = "object", Zr = (t, n) => n, bt = (t, n, r) => {
  const a = Kr(n.push(r) - 1);
  return t.set(r, a), a;
}, Xr = (t, n, r) => {
  const a = Zr, s = /* @__PURE__ */ new Map(), c = [], u = [];
  let f = +bt(s, c, a.call({ "": t }, "", t)), l = !f;
  for (; f < c.length; )
    l = !0, u[f] = qr(c[f++], p, r);
  return "[" + u.join(",") + "]";
  function p(h, g) {
    if (l)
      return l = !l, g;
    const m = a.call(this, h, g);
    switch (typeof m) {
      case Wr:
        if (m === null) return m;
      case Jr:
        return s.get(m) || bt(s, c, m);
    }
    return m;
  }
};
var P = /* @__PURE__ */ ((t) => (t.CONNECTED = "CONNECTED", t.DISCONNECTED = "DISCONNECTED", t.ERROR = "ERROR", t.TAGGED_FIELD_CLICKED = "TAGGED_FIELD_CLICKED", t.URL_CHANGED = "URL_CHANGED", t.SUBSCRIBED = "SUBSCRIBED", t.UNSUBSCRIBED = "UNSUBSCRIBED", t.ENTRY_UPDATED = "ENTRY_UPDATED", t.ENTRY_SAVED = "ENTRY_SAVED", t.DEBUG_MODE_ENABLED = "DEBUG_MODE_ENABLED", t))(P || {});
function Qr(t, n) {
  G(
    "TAGGED_FIELD_CLICKED",
    {
      action: "TAGGED_FIELD_CLICKED",
      ...t
    },
    n
  );
}
function kr(t, n) {
  G(
    "TAGGED_FIELD_CLICKED",
    {
      action: "TAGGED_FIELD_CLICKED",
      ...t
    },
    n
  );
}
class ei {
  subscriptions = /* @__PURE__ */ new Map();
  defaultLocale;
  sendMessage;
  constructor({ locale: n, targetOrigin: r }) {
    this.defaultLocale = n, this.sendMessage = (a, s) => G(a, s, r);
  }
  /** Receives the data from the message event handler and calls the subscriptions */
  async receiveMessage(n) {
    if (n.method === P.ENTRY_UPDATED) {
      const { data: r, subscriptionId: a } = n, s = this.subscriptions.get(a);
      s ? (s.callback(r), s.data = r, this.subscriptions.set(a, s)) : D.error("Received an update for an unknown subscription", {
        subscriptionId: a,
        data: r,
        subscriptions: this.subscriptions
      });
    }
  }
  /**
   * Subscribe to data changes from the Editor, returns a function to unsubscribe
   * Will be called once initially for the restored data
   */
  subscribe(n) {
    const r = Ar(), a = n.locale ?? this.defaultLocale;
    this.subscriptions.set(r, {
      ...n
    });
    const s = {
      locale: a,
      event: "edit",
      id: r,
      config: Xr(n)
    };
    return this.sendMessage(P.SUBSCRIBED, s), () => {
      this.sendMessage(P.UNSUBSCRIBED, s), this.subscriptions.delete(r);
    };
  }
}
class ti {
  locale;
  options;
  inspectorModeEnabled;
  subscription;
  constructor({
    locale: n,
    options: r,
    inspectorModeEnabled: a
  }) {
    this.locale = n, this.options = r, this.inspectorModeEnabled = a;
  }
  subscribe(n) {
    return this.subscription && D.log(
      "There is already a subscription for the save event, the existing one will be replaced."
    ), this.subscription = n, () => {
      this.subscription = void 0;
    };
  }
  receiveMessage(n) {
    if (n.method === P.ENTRY_SAVED && this.subscription) {
      const { entity: r } = n;
      this.inspectorModeEnabled ? Rt({ options: this.options }).includes(r.sys.id) && this.subscription(r) : this.subscription(r);
    }
  }
}
const si = Ct.version, Tt = [
  "https://app.contentful.com",
  "https://app.eu.contentful.com",
  "http://localhost:3001"
  // for local debugging for Contentful engineers
];
class Pe {
  static initialized = !1;
  static inspectorMode = null;
  static liveUpdates = null;
  static saveEvent = null;
  static inspectorModeEnabled = !0;
  static liveUpdatesEnabled = !0;
  static locale;
  static space;
  static environment;
  static sendMessage;
  static targetOrigin;
  // Static method to initialize the LivePreview SDK
  static init(n) {
    if (typeof n != "object" || !n?.locale)
      throw new Error(
        "Init function has to be called with a locale configuration (for example: `ContentfulLivePreview.init({ locale: 'en-US'})`)"
      );
    const {
      debugMode: r,
      enableInspectorMode: a,
      enableLiveUpdates: s,
      locale: c,
      environment: u,
      space: f,
      targetOrigin: l
    } = n;
    if (typeof window < "u") {
      if (!Ir())
        return this.liveUpdatesEnabled = !1, Promise.resolve(null);
      if (r && mt(r), typeof a == "boolean" && (this.inspectorModeEnabled = a), typeof s == "boolean" && (this.liveUpdatesEnabled = s), this.locale = c, this.space = f, this.environment = u, this.initTargetOrigin(l), this.initialized)
        return D.log("You have already initialized the Live Preview SDK."), Promise.resolve(Pe.inspectorMode);
      this.inspectorModeEnabled && (this.inspectorMode = new Yr({
        locale: c,
        space: f,
        environment: u,
        targetOrigin: this.targetOrigin,
        ignoreManuallyTaggedElements: n.experimental?.ignoreManuallyTaggedElements
      })), this.liveUpdatesEnabled && (this.liveUpdates = new ei({ locale: c, targetOrigin: this.targetOrigin }), this.saveEvent = new ti({
        locale: c,
        options: {
          locale: this.locale,
          space: this.space,
          environment: this.environment,
          targetOrigin: this.targetOrigin
        },
        inspectorModeEnabled: this.inspectorModeEnabled
      })), window.addEventListener("message", (I) => {
        if (wr(I)) {
          if (D.log("Received message", I.data), I.data.method === P.DEBUG_MODE_ENABLED) {
            mt(!0);
            return;
          }
          this.inspectorModeEnabled && this.inspectorMode?.receiveMessage(I.data), this.liveUpdatesEnabled && (this.liveUpdates?.receiveMessage(I.data), this.saveEvent?.receiveMessage(I.data));
        }
      }), br(() => {
        G(
          P.URL_CHANGED,
          {
            action: P.URL_CHANGED,
            taggedElementCount: document.querySelectorAll(
              `[${E.ENTRY_ID}]`
            ).length
          },
          this.targetOrigin
        );
      });
      const { taggedElements: p, manuallyTaggedCount: h, automaticallyTaggedCount: g } = this.inspectorModeEnabled ? ze({
        options: {
          locale: this.locale,
          space: this.space,
          environment: this.environment
        }
      }) : {
        taggedElements: [],
        manuallyTaggedCount: 0,
        automaticallyTaggedCount: 0
      }, m = p.length;
      return G(
        P.CONNECTED,
        {
          action: P.CONNECTED,
          connected: !0,
          tags: m,
          taggedElementCount: m,
          locale: this.locale,
          isInspectorEnabled: this.inspectorModeEnabled,
          isLiveUpdatesEnabled: this.liveUpdatesEnabled,
          manuallyTaggedElementCount: h,
          automaticallyTaggedElementCount: g
        },
        this.targetOrigin
      ), this.initialized = !0, Promise.resolve(Pe.inspectorMode);
    }
  }
  static initTargetOrigin(n) {
    if (n)
      this.targetOrigin = Array.isArray(n) ? n : [n];
    else {
      const r = window.location.ancestorOrigins, a = r ? Tt.find((s) => r.contains(s)) : (
        //less consistent workaround for Firefox, where ancestorOrigins is not supported
        Tt.find((s) => document.referrer.includes(s))
      );
      if (!a)
        throw new Error(
          "The current origin is not supported. Please provide a targetOrigin in the live preview configuration."
        );
      this.targetOrigin = [a];
    }
  }
  static subscribe(n, r) {
    if (!this.liveUpdatesEnabled)
      return () => {
      };
    const a = typeof n == "string" ? n : "edit", s = typeof n == "object" ? n : r;
    if (a === "save") {
      if (!this.saveEvent)
        throw new Error(
          "Save event is not initialized, please call `ContentfulLivePreview.init()` first."
        );
      return this.saveEvent.subscribe(s.callback);
    }
    if (!this.liveUpdates)
      throw new Error(
        "Live updates are not initialized, please call `ContentfulLivePreview.init()` first."
      );
    return this.liveUpdates.subscribe(s);
  }
  // Static method to render live preview data-attributes to HTML element output
  static getProps(n) {
    const { fieldId: r, locale: a, environment: s, space: c } = n;
    if (!this.inspectorModeEnabled)
      return null;
    if (r) {
      const u = {
        ...a ? { [E.LOCALE]: a } : {},
        ...s ? { [E.ENVIRONMENT]: s } : {},
        ...c ? { [E.SPACE]: c } : {},
        [E.FIELD_ID]: r
      };
      if (a && (u[E.LOCALE] = a), n.assetId !== void 0)
        return {
          ...u,
          [E.ASSET_ID]: n.assetId
        };
      if (n.entryId !== void 0)
        return {
          ...u,
          [E.ENTRY_ID]: n.entryId
        };
    }
    return D.warn("Missing property for inspector mode", { ...n }), null;
  }
  static toggleInspectorMode() {
    return this.inspectorModeEnabled = !this.inspectorModeEnabled, this.inspectorModeEnabled;
  }
  static toggleLiveUpdatesMode() {
    return this.liveUpdatesEnabled = !this.liveUpdatesEnabled, this.liveUpdatesEnabled;
  }
  //TODO: Rename to openEntityInEditor, as assets can also be opened. Would be breaking change
  static openEntryInEditor(n) {
    const r = {
      locale: this.locale,
      environment: this.environment,
      space: this.space
    };
    if (n.assetId !== void 0 && n.fieldId) {
      kr(
        {
          ...r,
          ...n
        },
        this.targetOrigin
      );
      return;
    }
    if (n.entryId !== void 0 && n.fieldId) {
      Qr(
        {
          ...r,
          ...n
        },
        this.targetOrigin
      );
      return;
    }
    D.error("Please provide field id and entry/asset id to openEntryInEditor.", { ...n });
  }
  /**
   * Returns a list of tagged entries on the page
   */
  static getEntryList() {
    return Rt({
      options: {
        locale: this.locale,
        space: this.space,
        environment: this.environment
      }
    });
  }
}
export {
  Pe as C,
  k as I,
  Tr as L,
  si as V,
  _r as a,
  P as b,
  kr as c,
  Sr as d,
  ri as f,
  Lr as i,
  ii as l,
  Qr as o,
  Hr as p,
  ni as u
};
//# sourceMappingURL=index-CCtUt9Tt.js.map
